import React from 'react';
type RedoIconProps = {
  width?: string;
  height?: string;
  color?: string;
};
function RedoIcon({
  width = '30',
  height = '29',
  color = 'black',
}: RedoIconProps) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 30 29'
      fill='none'
    >
      <path
        d='M5.40039 24.0008V22.3208C5.40039 18.2884 5.40039 16.2722 6.18514 14.7321C6.87543 13.3773 7.97689 12.2758 9.33166 11.5855C10.8718 10.8008 12.888 10.8008 16.9204 10.8008H24.6004M24.6004 10.8008L18.6004 16.8008M24.6004 10.8008L18.6004 4.80078'
        stroke={color}
        stroke-width='3'
        stroke-linecap='round'
        stroke-linejoin='round'
      />
    </svg>
  );
}

export default RedoIcon;
